import { c as _c } from "react/compiler-runtime";
import { getEntitiesByFpIdTagsOptions } from '@onefootprint/fetch-dashboard';
import { useQuery } from '@tanstack/react-query';
import { AnimatePresence, easeInOut, motion } from 'framer-motion';
import useEntityId from '@/entity/hooks/use-entity-id';
import Tag from './components/tag';
const Tags = () => {
  const $ = _c(12);
  const entityId = useEntityId();
  let t0;
  if ($[0] !== entityId) {
    t0 = getEntitiesByFpIdTagsOptions({
      path: {
        fpId: entityId
      }
    });
    $[0] = entityId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = !!entityId;
  let t2;
  if ($[2] !== t0 || $[3] !== t1) {
    t2 = {
      ...t0,
      enabled: t1
    };
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    data: tags
  } = useQuery(t2);
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      initial: {
        filter: "blur(10px)",
        opacity: 0
      },
      animate: {
        filter: "blur(0px)",
        opacity: 1
      },
      exit: {
        filter: "blur(10px)",
        opacity: 0
      }
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const tagVariants = t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      height: "auto",
      opacity: 1,
      transition: {
        duration: 0.1,
        ease: easeInOut
      }
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      open: t4,
      closed: {
        height: 0,
        opacity: 0,
        transition: {
          duration: 0.1,
          ease: easeInOut
        }
      }
    };
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const containerVariants = t5;
  let t6;
  if ($[8] !== tags) {
    t6 = tags && tags.length > 0 && <motion.div initial="closed" animate="open" exit="closed" variants={containerVariants} transition={{
      duration: 0.1,
      ease: easeInOut
    }} className="overflow-hidden"><div className="flex flex-wrap items-center gap-1 md:flex-nowrap"><AnimatePresence>{tags.map(t7 => {
            const {
              id,
              tag
            } = t7;
            return <motion.div key={id} variants={tagVariants} initial="initial" animate="animate" exit="exit" transition={{
              duration: 0.3
            }}><Tag text={tag} /></motion.div>;
          })}</AnimatePresence></div></motion.div>;
    $[8] = tags;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t6) {
    t7 = <AnimatePresence>{t6}</AnimatePresence>;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};
export default Tags;